import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React from "react";
import { MARK_AS_TASK_CONFIGURABLE } from "../../../graphql/mutations";
import { handleError } from "../../../helper";

export default function BulkMarkTaskConfigurable({
  open,
  toggleShowModal,
  toggleActive,
  onNotificationChange,
  idsChecked,
  onCompleted,
}) {
  let timeoutRef = React.useRef(null);
  const [markTaskConfigurable, { loading }] = useMutation(
    MARK_AS_TASK_CONFIGURABLE,
    {
      onError: (error) => {
        onNotificationChange &&
          onNotificationChange({
            message: handleError(error.toString()),
            isError: true,
          });
      },
      onCompleted: () => {
        onNotificationChange &&
          onNotificationChange({
            message: "Mark task configurable success.",
            isError: false,
          });

        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          onCompleted && onCompleted();
        }, 2000);
      },
    },
  );

  const handleSubmit = React.useCallback(() => {
    onNotificationChange &&
      onNotificationChange({
        message: null,
        isError: false,
      });

    toggleActive && toggleActive();

    markTaskConfigurable({
      variables: {
        taskIDs: idsChecked,
      },
    });
  }, [
    markTaskConfigurable,
    idsChecked,
    toggleActive,
    toggleShowModal,
  ]);

  return (
    <Modal
      title="Mark as Configurable"
      open={open}
      onClose={toggleShowModal}
      sectioned
      secondaryActions={[{ content: "Cancel", onAction: toggleShowModal }]}
      primaryAction={{
        content: "Submit",
        onAction: handleSubmit,
        loading: loading,
      }}
    >
      <p>Are you sure want to mark this task to Artwork Configurable?</p>
    </Modal>
  );
}
